module.exports = __webpack_public_path__ + "static/media/4.17.e6438aa5.png";